import { Item } from './item';

export const ITEMS: Item[] = [
  {
    title: '',
    image: '',
    market: 'incremental',
    technology: 'incremental',
    description: 'Incremental improvements of existing product and service',
  }, {
    title: '',
    image: '',
    market: 'incremental',
    technology: 'disruptive',
    description: 'Major technology changes in existing product',
  }, {
    title: '',
    image: '',
    market: 'incremental',
    technology: 'breakthrough',
    description: 'A totally different product but same service',
  }, {
    title: '',
    image: '',
    market: 'disruptive',
    technology: 'incremental',
    description: 'Product-based service innovation, with existing product',
  }, {
    title: '',
    image: '',
    market: 'disruptive',
    technology: 'disruptive',
    description: 'Product-based service innovation, with major technology changes',
  }, {
    title: '',
    image: '',
    market: 'disruptive',
    technology: 'breakthrough',
    description: 'Product-based service innovation, with totally different product',
  }, {
    title: '',
    image: '',
    market: 'breakthrough',
    technology: 'incremental',
    description: 'Global challenges driven service innovation, using existing product',
  }, {
    title: '',
    image: '',
    market: 'breakthrough',
    technology: 'disruptive',
    description: 'Global challenges driven service innovation, using product with major technology changes',
  }, {
    title: '',
    image: '',
    market: 'breakthrough',
    technology: 'breakthrough',
    description: 'Global challenges driven service innovation, using totally different product',
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/transition-matrix/items/items.ts